import { EmployeeFormError } from 'types/state';
import { LoginInUseError } from 'utils/errors';

export const getEmployeeEditorFormErrorFromServiceError = (
  error: Error
): EmployeeFormError => {
  if (error instanceof LoginInUseError) {
    return 'LOGIN_IN_USE';
  }

  return 'SERVICE_FAILED';
};
